import { useEffect, useRef, useState } from 'react';
import { WidgetProps } from '@rjsf/core';
import JsonQuery from 'json-query';
import { Dropdown } from 'react-bootstrap';

const FormDataMultiSelect = (props: WidgetProps) => {
    const { label, uiSchema, formContext, value, placeholder, onChange } = props;
    const [selectedOptions, setSelectedOptions] = useState<string[]>(
        value ? value?.split(',') : []
    );
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<any>(null);
    const dropdownToggleRef = useRef<any>(null);

    const { dataKey } = uiSchema?.customProps;
    const rootFormData = formContext?.rootFormData;
    const dropDownOptions = JsonQuery(dataKey as string, { data: rootFormData }).value || [];

    // handle if click outside of drodown and toggle icon
    const handleClickOutside = (e: any) => {
        // check if click is outside od dropdown and toggle icon
        if (
            dropdownRef?.current &&
            !dropdownRef.current.contains(e.target) &&
            dropdownToggleRef?.current &&
            !dropdownToggleRef.current.contains(e.target)
        ) {
            // close drodown on click outside
            setIsOpen(false);
        }
    };

    useEffect(() => {
        // event listener to check if click outside of component
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // remove the event listener
            document.removeEventListener('mousedown', handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dropdownRef]);

    useEffect(() => {
        const parentElem = formContext?.editorRef;
        // This function will be called when the scroll event occurs
        const handleScroll = () => {
            // Close the dropdown by setting showDropdown to false
            setIsOpen(false);
        };

        // Add an event listener to the window object for the scroll event
        window.addEventListener('scroll', handleScroll);
        parentElem?.addEventListener('scroll', handleScroll);

        // Clean up the event listener when the component is unmounted
        return () => {
            window.removeEventListener('scroll', handleScroll);
            parentElem?.removeEventListener('scroll', handleScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOptionClick = (option: any) => {
        const selectedIndex = selectedOptions.indexOf(option);
        if (selectedIndex === -1) {
            setSelectedOptions([...selectedOptions, option]);
            const _value = [...selectedOptions, option].join();
            onChange(_value);
        } else {
            const updatedOptions = [...selectedOptions];
            updatedOptions.splice(selectedIndex, 1);
            setSelectedOptions(updatedOptions);
            const _value = updatedOptions.join();
            onChange(_value);
        }
    };

    return (
        <div className="form-data-multi-select">
            {label && <label className="label">{label}</label>}
            <Dropdown
                className="dropdown"
                ref={dropdownRef}
                show={isOpen}
                onToggle={() => setIsOpen(!isOpen)}
            >
                <Dropdown.Toggle ref={dropdownToggleRef} as={'div'}>
                    {selectedOptions && selectedOptions.length > 0 ? (
                        <span>{`${selectedOptions[0]} ${
                            selectedOptions.length > 1 ? `+${selectedOptions.length - 1}` : ''
                        }`}</span>
                    ) : (
                        <span>{placeholder || 'Select Option'}</span>
                    )}
                    <i
                        className={`dropdown-toggle-icon fas ${
                            isOpen ? 'fa-chevron-up' : 'fa-chevron-down'
                        }`}
                    />
                </Dropdown.Toggle>
                <Dropdown.Menu className={'dropdown-menu'}>
                    {dropDownOptions &&
                        dropDownOptions.length &&
                        dropDownOptions?.map((option: any) => (
                            <div
                                key={option}
                                className={`dropdown-item ${
                                    selectedOptions?.includes(option) ? 'selected' : ''
                                }`}
                                tabIndex={0}
                            >
                                <input
                                    className="item-checkbox"
                                    type="checkbox"
                                    id={option}
                                    checked={selectedOptions.indexOf(option) !== -1}
                                    onChange={() => handleOptionClick(option)}
                                />
                                <label className="dropdown-item-label" htmlFor={option}>
                                    {option}
                                </label>
                            </div>
                        ))}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default FormDataMultiSelect;
